import { TFnType } from '@tolgee/react'
import { HoldTypeChipsCell } from '@tom-ui/planning/components/hold/DisplayHoldsButton'
import { ContainerJourneyStatusChip } from '@tom-ui/planning/components/molecules/ContainerJourneyStatusChip'
import { columnFilterPresets } from '@tom-ui/planning/pages/VesselVisit/tableConfigs/columnFilterConfigs'
import { TomTableEmptyCell, YesNoBadge } from '@tom-ui/ui'
import { ContainerNumber, formatPosition } from '@tom-ui/utils'
import { MRT_ColumnDef } from 'material-react-table'
import { ContainerTurnoverListTableColumnsDto } from '../stores/container-turnover-list.view-store'

export const getContainerTurnoverListColumns = (
  t: TFnType,
): MRT_ColumnDef<ContainerTurnoverListTableColumnsDto>[] => [
  {
    accessorKey: 'number',
    header: t('containerNo', 'Container No.'),
    size: 150,
    Cell: ({ renderedCellValue }) =>
      renderedCellValue ? (
        <ContainerNumber value={String(renderedCellValue)} format={false} />
      ) : null,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'status',
    header: t('status', 'Status'),
    size: 150,
    ...columnFilterPresets.orderStatusMultiSelect(),
    Cell: cell => <ContainerJourneyStatusChip status={cell.row.original.status ?? '-'} />,
  },
  {
    accessorKey: 'plannedYardLocation',
    header: t('plannedYardPosition', 'Planned yard position'),
    size: 250,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'currentYardLocation',
    header: t('currentYardPosition', 'Current yard position'),
    size: 250,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'approved',
    header: t('approved', 'Approved'),
    size: 80,
    ...columnFilterPresets.yesNoSelect(),
    Cell: cell => <YesNoBadge isYes={cell.row.original.approved?.toLowerCase() === 'yes'} />,
  },
  {
    accessorKey: 'hold',
    header: t('holdTypes', 'Hold Types'),
    size: 300,
    ...columnFilterPresets.arrayContainsValue(),
    Cell: cell => <HoldTypeChipsCell containerJourneyId={cell.row.original.containerJourneyId} />,
  },
  {
    accessorKey: 'archetype',
    header: t('archetype', 'Archetype'),
    size: 100,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'category',
    header: t('category', 'Category'),
    size: 150,
    ...columnFilterPresets.importTransshipmentOverlanded(),
  },
  {
    accessorKey: 'shippingLine',
    header: t('shippingLine', 'Shipping line'),
    size: 150,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'forwarder',
    header: t('forwarder', 'Forwarder'),
    size: 150,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'consignee',
    header: t('consignee', 'Consignee'),
    size: 80,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'cargoStatus',
    header: t('cargoStatus', 'Cargo status'),
    size: 170,
    ...columnFilterPresets.fullEmptySelect(),
  },
  {
    accessorKey: 'pol',
    header: t('pol', 'POL'),
    size: 80,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'grossWeight',
    header: t('grossWeight', 'Gross weight'),
    size: 150,
    ...columnFilterPresets.numericMandatory(),
  },
  {
    accessorKey: 'sealNo',
    header: t('sealNo', 'Seal no.'),
    size: 150,
    ...columnFilterPresets.arrayContainsValue(),
  },
  {
    accessorKey: 'documentNo',
    header: t('releaseReference', 'Release ref.'),
    size: 150,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'bl',
    header: t('bl', 'B/L'),
    size: 150,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'imoClass',
    header: t('imoClass', 'IMO class'),
    size: 150,
    ...columnFilterPresets.arrayContainsValue(),
  },
  {
    accessorKey: 'oog',
    header: t('oog', 'OOG'),
    size: 80,
    ...columnFilterPresets.yesNoSelect(),
  },
  {
    accessorKey: 'cooling',
    header: t('cooling', 'Cooling'),
    size: 80,
    ...columnFilterPresets.yesNoSelect(),
  },
  {
    accessorKey: 'inboundPos',
    header: t('inboundPos', 'Inbound pos.'),
    size: 180,
    Cell: TomTableEmptyCell,
    accessorFn: row => (row.originPosition ? formatPosition(row.originPosition) : undefined),
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'inlandDest',
    header: t('inlandDest', 'Inland dest.'),
    size: 200,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
]
